import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTradeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12.5962 12.5962C15.1346 10.0578 15.1346 5.94221 12.5962 3.40381C11.327 2.1346 9.6635 1.5 8 1.5M12.5962 12.5962H14.7175M12.5962 12.5962V10.4749" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.40379 3.40381C0.865383 5.94222 0.865383 10.0578 3.40379 12.5962C4.673 13.8654 6.33649 14.5 7.99999 14.5M3.40379 3.40381H1.28247M3.40379 3.40381V5.52513" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 10.5C9.75 11.25 9.08985 11.75 8.25 11.75C6.75 11.75 6 10 6 8C6 6 6.75 4.25 8.25 4.25C9.08985 4.25 9.75 4.75 10 5.5M5 6.75H7.5M5 9.25H7.5" })
	]
});
export default SvgTradeIcon;
